<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$search"
    :title="$t('searcher')"
    :loading="loading"
    :max-width="800"
    color="search"
    activator-button
    @open="showDialog"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-container>
        <v-card-title>
          <v-row class="ma-0">
            <v-text-field
              v-model="pattern"
              append-icon="$search"
              class="ml-auto"
              hide-details
              :label="$t('search_records')"
              single-line
            />
          </v-row>
        </v-card-title>
        <v-data-table
          :headers="result_headers"
          :items="result"
          dense
          class="elevation-1"
          :loading="loading"
          :item-class="rowClasses"
        >
          <template #item.actions="{item}">
            <tooltip-btn
              v-if="item.enable === true"
              color="green"
              icon="mdi-skip-next"
              tooltip="tooltip_selection"
              @click="selection(item)"
            />
          </template>
        </v-data-table>
      </v-container>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call, get } from 'vuex-pathify'
  import CumulusInfoDialog from '@/components/InfoDialog'

  export default {
    name: 'Searcher',
    components: { CumulusInfoDialog },
    props: {
      type: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        expanded: [],
        singleExpand: true,
        result: [],
        dialogInfo: false,
        loading: false,
        pattern: '',
      }
    },
    computed: {
      result_headers () {
        return [
          {
            text: this.$t('fields.result'),
            value: 'result',
          },
          {
            // text: this.$t('actions'),
            sortable: false,
            value: 'actions',
            align: 'right',
            width: '200px',
          },
        ]
      },
      profile: get('auth/profile'),
    },
    watch: {
      dialogInfo (val) {
        // this.showDialogFlightInfo()
        val || this.closeDialog()
      },
      pattern: {
        handler () {
          console.log('search')
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.refresh()
          }, 800)
        },
        deep: true,
      },
    },
    mounted () {
    },
    methods: {
      search: call('datasource/globalSearch'),
      async showDialog () {
        console.log('showDayStat')
        // this.loading = true
      },
      async refresh () {
        this.loading = true
        await this.search({ type: this.type, pattern: this.pattern }).then(response => {
          this.result = response
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.result = []
        this.pattern = ''
        this.dialogInfo = false
      },
      selection (item) {
        this.$emit('selected', item)
        this.closeDialog()
      },
      rowClasses (item) {
        if (!item.enable) {
          return 'red lighten-5'
        }
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
